var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateIconInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 48,
    height: 56,
    rx: 4,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 24,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#E0E0E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 32,
    width: 28,
    height: 4,
    rx: 2,
    fill: "#E0E0E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 44,
    width: 32,
    height: 8,
    rx: 2,
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIconInvoice);
export default __webpack_public_path__ + "static/media/template-icon-invoice.9b7a9ce97f58451e8c4a474b904fbcf3.svg";
export { ForwardRef as ReactComponent };